import * as React from "react";

import {
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemButton,
} from "@mui/material";

import LanguageIcon from "@mui/icons-material/Language";

import { NOT_PROVIDED } from "../common/sudCard";

export const WeblinkListItem = ({ weblink }) => {
  if (!weblink) {
    return (
      <ListItem aria-label="website" disablePadding dense>
        <ListItemIcon>
          <LanguageIcon />
        </ListItemIcon>
        <ListItemText primary="Website" secondary={NOT_PROVIDED} />
      </ListItem>
    );
  }

  return (
    <ListItemButton
      aria-label="website"
      href={weblink}
      rel="noopener noreferrer"
      target="_blank"
      component="a"
      disablePadding
      dense
    >
      <ListItemIcon>
        <LanguageIcon />
      </ListItemIcon>
      <ListItemText
        primary="Website"
        secondary={weblink ? "Click here" : NOT_PROVIDED}
      />
    </ListItemButton>
  );
};
